import { requestConfirmation } from "../lib/confirmation";
import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLAnchorElement> {
  static values = {
    unlinkUrl: String,
    message: String,
  }

  declare unlinkUrlValue: string
  declare messageValue: string

  async confirm(event: Event) {
    event.preventDefault()
    event.stopPropagation()

    if (!await requestConfirmation(this.messageValue, { intent: 'destructive', icon: 'unlink' })) return

    const csrfToken = document.querySelector<HTMLMetaElement>(
      'meta[name="csrf-token"]'
    )?.content

    try {
      const response = await fetch(this.unlinkUrlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": csrfToken || "",
          "Accept": "text/html",
        },
      })

      if (!response.ok) {
        console.error("Failed to unlink template: server returned", response.status)
        alert("Something went wrong. Please try again.")
        return
      }

      const frameId = this.element.dataset.turboFrame
      const frame = document.querySelector(`turbo-frame#${frameId}`)
      if (frame) {
        frame.setAttribute("src", this.element.href)
      }
    } catch (error) {
      console.error("Failed to unlink template:", error)
      alert("Something went wrong. Please try again.")
    }
  }
}
